<script>
import Api from './api'
import i18n from './i18n'
import { requestTemplate } from './request'
import TwoStepsImport from '../../../../two-steps-import/index.vue'
import {popoverStatus} from '../../../../header-process-popover/popover-status.js'
import { HEADER_PARAMS_KEYS } from '../../../utils/share'
const pageText = window.fe.getPageText(i18n)

export default {
  components: {
    TwoStepsImport
  },
  props: {
    objectApiName: {
      type: String,
      default: ''
    },
    operationApiName: {
      type: String,
      default: ''
    },
    layoutApiName: {
      type: String,
      default: ''
    },
    tenantType: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      downloadTemplate: {
        url: `/${window.fe.project}/upload/download`,
        type: 'get',
        params: {}
      },
      exportButtonApiName: {},
      submitImportConfig: {
        type: Api.import.type,
        url: '',
        params: {},
        tenantType: '',
        importTemplateApiName: '',
        headers: {}
      }
    }
  },
  methods: {
    async handleImport (buttonItem) {
      const content = await requestTemplate({
        objectApiName: buttonItem.objectApiName || this.objectApiName,
        buttonApiName: buttonItem.apiName
      })
      if (!content) {
        this.$message.error(pageText.templateIncorrect)
        return
      }
      const { templateApiName, url, fileName, rowLimit, allowAtomic } = content
      this.downloadTemplate.params.url = url
      this.downloadTemplate.params.name = fileName
      this.importTemplateApiName = templateApiName
      this.importConfig = { allowAtomic, rowLimit }
      this.exportButtonApiName = {
        buttonApiName: buttonItem.apiName,
        operationApiName: buttonItem.permissionPointApiName || this.operationApiName
      }
      this.$refs.importDialog.showImportDialog()
    },
    renderTip ({tip}) {
      const {allowAtomic, rowLimit} = this.importConfig || {}
      const importLimit = pageText.importLimit + rowLimit
      return (
        <p class='import-tip'>
          <p>1. {tip}</p>
          <p>2. {importLimit}</p>
          {allowAtomic? 
            <p>3. {pageText.importTypeAll}<br/>{pageText.importAllDes}</p> 
            : <p>3. {pageText.importTypePartially}<br/>{pageText.importPartiallyDes}</p>  } 
        </p>
      )
    },
    // 文件上传成功的回调
    async uploadSuccess (res) {
      const { url } = Api.import
      this.submitImportConfig.params.resourceUrl = res.content.key
      this.submitImportConfig.url = `${url}/${this.objectApiName}/${this.exportButtonApiName.operationApiName || this.operationApiName}`
      this.submitImportConfig.tenantType = this.tenantType
      this.submitImportConfig.importTemplateApiName = this.importTemplateApiName
      this.submitImportConfig.headers = {
        [HEADER_PARAMS_KEYS.tenantType]: this.tenantType,
        [HEADER_PARAMS_KEYS.objectApiName]: this.objectApiName,
        [HEADER_PARAMS_KEYS.layoutApiName]: this.layoutApiName,
        [HEADER_PARAMS_KEYS.operationApiName]: this.operationApiName
      } 
    },
    // 提交
    async submitSuccess () {
      popoverStatus.show()
    }
  },
  render () {
    const { downloadTemplate, extendParam, submitImportConfig } = this
    return (
      <two-steps-import
        ref="importDialog"
        dialogTitle={pageText.backMall}
        dialogWidth="480px"
        autoUpload={true}
        downloadTemplateConfig={downloadTemplate}
        extend={extendParam}
        isChunk={true}
        submitImportConfig={submitImportConfig}
        on={{
          'upload-success': this.uploadSuccess,
          'submit-success': this.submitSuccess
        }}
        scopedSlots={{
          tipSlot: this.renderTip
        }}
      />
    )
  }
}
</script>

<style>
</style>